import { render, staticRenderFns } from "./PackageSelector.vue?vue&type=template&id=1cb201a2"
import script from "./PackageSelector.vue?vue&type=script&lang=ts&setup=true"
export * from "./PackageSelector.vue?vue&type=script&lang=ts&setup=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/PortfolioWeb/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1cb201a2')) {
      api.createRecord('1cb201a2', component.options)
    } else {
      api.reload('1cb201a2', component.options)
    }
    module.hot.accept("./PackageSelector.vue?vue&type=template&id=1cb201a2", function () {
      api.rerender('1cb201a2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "ClientScripts/Components/PackageSelector/PackageSelector.vue"
export default component.exports